import { Component, OnInit ,ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { CountryModel } from 'src/app/masters/country/country.model';
import { MasterService } from 'src/app/masters/master.service';
import { OrganismModel } from '../organisms/organism.model';
import { PartnersService } from '../partners.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import * as CommonConstants from '../../utils/common.constants';
import { AddFinancialComponent } from './add-financial/add-financial.component';
import { PartnerSearchComponent } from '../partner-search/partner-search.component';
import { LoaderService } from 'src/app/common/loader.service';
import { SharedService } from 'src/app/utils/shared.service';

@Component({
  selector: 'app-financials',
  templateUrl: './financials.component.html',
  styleUrls: ['./financials.component.scss']
  
})
export class FinancialsComponent implements OnInit {

  organisms: OrganismModel[];
  townList: any = [];
  countryList: any = [];
  columnDefs: any[];
  addFinancial;
  startIndex;
  rowsPerPage;
  totalRecords;
  paginationSize = CommonConstants.PAGINATION_SIZE;
  financialSearchForm: FormGroup;
  rowData: any[];
  toggleColumn = true;
  @ViewChild(PartnerSearchComponent,{static:true})   pSearch : PartnerSearchComponent;
  addressTypeList : any[];
  
  newFinancial: AddFinancialComponent;
  priv_addFina: boolean;
  @ViewChild(AddFinancialComponent, { static: true }) set Content(newfinancialRef) {
    this.newFinancial = newfinancialRef;
  }

  constructor(public router: Router,private partnerService:PartnersService,private formBuilder: FormBuilder,
    private masterService: MasterService, private loaderService: LoaderService,private sharedService:SharedService) {

    this.columnDefs = [
      // { headerName: 'Id', field: 'finanId' },
      { headerName: 'Name', field: 'compaVaNameEn' },
      { headerName: 'Organism', field: 'orgName'},
      { headerName: 'Work Phone', field: 'compaVaWorkPhone' },
      { headerName: 'Mobile Phone', field: 'compaVaMobilePhone1' },
      { headerName: 'Email', field: 'compaVaEmail'}       
    ];
    this.getFromGroup();  
   }

  ngOnInit() {
    this.priv_addFina=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_FINANCIAL);
    this.pSearch.pSearch["active"]=true;
    this.pSearch.partnerType=CommonConstants.PARTNER_FINANCIAL_TYPE;
  }
  addNewFinancial() {
    this.router.navigate(['addFinancial']);
    this.newFinancial.addFinancialTitle = true;
    this.newFinancial.editFinancialTitle = false;
  }
  hideRightDiv() {
    this.addFinancial = false;
    this.toggleColumn = true;
  }
  private getFromGroup() {
    this.financialSearchForm = this.formBuilder.group({
      'orgsmId':  new FormControl(),
      'name': new FormControl(),
      'cotryId': new FormControl(),
      'townId' : new FormControl()
    })
    this.loadMasterData();
  }
  loadMasterData() {
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.townList = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countryList = response['result'];
      }
    });
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
      this.searchFinancial();
    })
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });

  }
  searchFinancial() {
    //this.addLogistics = false;
    this.startIndex = 0;
    this.rowsPerPage = CommonConstants.PAGINATION_SIZE;
    //this.paginatedList();
    this.pSearch.pSearch['partnerType'] = 8;
    this.pSearch.pSearch['active']=this.pSearch.pSearch['active'] ? 'A' :'I';
      this.loaderService.display(true);
      this.partnerService.searchFinance(this.pSearch.pSearch, this.startIndex).subscribe(response => {
        this.loaderService.display(false);
        response['result']=response['result'].map(item => ({...item,
          orgName: item.orgsmId ? this.organisms.find(obj => obj.orgsmId === item.orgsmId).compaVaNameEn : null }))
          this.rowData = response['result'];
      },
      error => {
        this.loaderService.display(false);
      })
    this.hideRightDiv();
  }
  reset(){
    this.financialSearchForm.reset();
    this.rowData =[];
    this.pSearch.pSearch={};
    this.hideRightDiv();
  }
 
  loadFinanceById(event: any) {
    let finance={
      "id":event.data.finanId
    }
    this.loaderService.display(true);
    this.partnerService.searchFinance(finance, this.startIndex).subscribe(response => {
      this.loaderService.display(false);
      this.newFinancial.hospDepartment.departmentList = [];
      this.newFinancial.hospAddress.addressList = [];
      this.newFinancial.hospContact.contactList=[];
      if (response['code'] == 'S0000') {
        let result = response['result'][0];
        this.newFinancial.FinancialForm.patchValue({
          finanId: result["finanId"],
          orgsmId: result["orgsmId"],
          compaVaNameEn: result["compaVaNameEn"],
          pacatId: result["pacatId"],
          pctypId: result["pctypId"],
          compaVaWorkPhone: result["compaVaWorkPhone"],
          compaVaWorkFax: result["compaVaWorkFax"],
          compaVaMobilePhone1: result["compaVaMobilePhone1"],
          compaVaMobilePhone2: result["compaVaMobilePhone2"],
          compaVaEmail: result["compaVaEmail"],
          compaVaHomepage: result["compaVaHomepage"],
          leforId: result["leforId"],
          compaNuNumberEmployees: result["compaNuNumberEmployees"],
          agmntId: result["agmntId"],
          certiId: result["certiId"],
          pagrpId: result["pagrpId"],
          staRecCode: result["staRecCode"] ==='A' ? true : false
        });

        result['addressList'] = result.addressList.map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description : null,
          townName: item.townId ? this.townList.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countryList.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        })); 
         this.newFinancial.hospDepartment.departmentList = JSON.parse(JSON.stringify(result['departmentList']));
         this.sharedService.setOrganismDepartment(this.newFinancial.hospDepartment.departmentList);
        this.newFinancial.hospAddress.addressList = JSON.parse(JSON.stringify(result['addressList']));
        this.newFinancial.hospContact.employeeList = JSON.parse(JSON.stringify(result['employeeList']));
        this.newFinancial.phoneNos.forEach(phone => {
          phone.phone=phone.getInternationPhoneFormat(result[phone.type]);
      })
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  onRowClicked(event: any) {
    this.addFinancial = true;
    this.toggleColumn = false;
    this.newFinancial.addFinancialTitle = false;
    this.newFinancial.editFinancialTitle = true;
    this.loadFinanceById(event);
   }
}
